module.exports = __webpack_public_path__ + "static/img/log_3.98c68c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/log_3.jpg
// module id = UszY
// module chunks = 1